import React from 'react';

export const NoCheckedCheckBoxIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='20' height='20' rx='6' fill='white' />
      <rect
        x='0.5'
        y='0.5'
        width='19'
        height='19'
        rx='5.5'
        stroke='#96A0B5'
        strokeOpacity='0.4'
      />
    </svg>
  );
};
